import { useQuery } from '@apollo/client';
import { GET_BESTREV } from '../gql/gql-bestrev';

export type UseHookArgs = {
  brandCode: string;
  callback: () => void;
  useCache?: boolean;
};

export function useBestrev(a: UseHookArgs) {
  const { brandCode, callback, useCache } = a;
  return useQuery(GET_BESTREV, {
    variables: {
      brandCode,
      useCache,
    },
    skip: !brandCode,
    onCompleted: () => callback(),
  });
}
